interface WalletBalanceCardProps {
  balance: number;
  isLoading?: boolean;
  onDeposit?: () => void;
  onWithdraw?: () => void;
  onRefresh?: () => void;
}

export function WalletBalanceCard({
  balance,
  isLoading = false,
  onDeposit,
  onWithdraw,
  onRefresh,
}: WalletBalanceCardProps) {
  return (
    <div className="flex w-full flex-col gap-4 rounded-2xl border border-primary/20 bg-primary/5 dark:border-primary/50 dark:bg-primary/10 p-4">
      <div className="flex flex-col gap-1 text-center relative">
        <div className="flex items-center justify-center">
          <p className="text-gray-500 dark:text-gray-300 text-sm font-medium leading-normal">
            Account Balance
          </p>
          {onRefresh && (
            <button
              onClick={onRefresh}
              disabled={isLoading}
              className="absolute right-0 flex items-center justify-center w-8 h-8 rounded-full hover:bg-white/10 transition-colors disabled:opacity-50"
              title="Refresh balance"
            >
              <span
                className={`material-symbols-outlined text-gray-500 dark:text-gray-400 text-lg ${
                  isLoading ? "animate-spin" : ""
                }`}
              >
                refresh
              </span>
            </button>
          )}
        </div>
        {isLoading ? (
          <div className="flex items-center justify-center h-12">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          </div>
        ) : (
          <p className="text-gray-900 dark:text-white tracking-tight text-4xl font-extrabold leading-tight">
            ${balance.toFixed(2)}
          </p>
        )}
      </div>
      <div className="flex gap-3">
        <button
          onClick={onDeposit}
          className="flex h-12 flex-1 cursor-pointer items-center justify-center gap-2 overflow-hidden rounded-2xl bg-primary/20 px-4 text-primary text-base font-bold leading-normal tracking-[0.015em] hover:bg-primary/30 transition-colors"
        >
          <span className="material-symbols-outlined">add</span>
          <span>Deposit</span>
        </button>
        <button
          onClick={onWithdraw}
          className="flex h-12 flex-1 cursor-pointer items-center justify-center gap-2 overflow-hidden rounded-2xl bg-card-light dark:bg-black/20 px-4 text-gray-900 dark:text-white text-base font-bold leading-normal tracking-[0.015em] hover:bg-gray-100 dark:hover:bg-black/30 transition-colors"
        >
          <span className="material-symbols-outlined">arrow_outward</span>
          <span>Withdraw</span>
        </button>
      </div>
    </div>
  );
}
